var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNumberSquareSix = function SvgIconNumberSquareSix(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.262 6.641a1 1 0 0 1 .347 1.371l-1.34 2.248a3.625 3.625 0 1 1-3.284 1.602l2.906-4.874a1 1 0 0 1 1.371-.347m-2.705 6.485a1.625 1.625 0 1 0 .113-.185l-.08.134z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 4.5c0-.966.784-1.75 1.75-1.75h15c.966 0 1.75.784 1.75 1.75v15a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75zm2 .25v14.5h14.5V4.75z"
  }))));
};
export default SvgIconNumberSquareSix;